import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SystemTranslationProgress from './SystemTranslationProgress';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import SystemTranslationInstructionVideoProgressService from '../services/SystemTranslationInstructionVideoProgressService';

class SystemTranslationInstructionVideoProgressContainer extends Component {
  systemTranslationInstructionVideoProgressService = new SystemTranslationInstructionVideoProgressService();

  componentDidMount() {
    this.systemTranslationInstructionVideoProgressService.init(this.props.locale);
  }

  render() {
    return (
      <SystemTranslationProgress
        title="Instruction Videos"
        percentage={this.systemTranslationInstructionVideoProgressService.progress.percentage}
        total={this.systemTranslationInstructionVideoProgressService.progress.translated}
        fetching={this.systemTranslationInstructionVideoProgressService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/instruction-videos',
            query: { localeMissingVideo: this.props.locale.key },
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

SystemTranslationInstructionVideoProgressContainer.propTypes = {
  locale: PropTypes.shape({
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(SystemTranslationInstructionVideoProgressContainer);
